import {
    Edit,
    TextInput,
    SimpleForm,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import * as React from "react";

export const CategoryEdit = props => (
    <Edit { ...props }>
        <SimpleForm>
            <TextInput source="name"/>
            <ReferenceInput source="messengerIntegrationId" reference="messenger">
                <SelectInput optionText={(r) => `${r.messengerName} ${r.botName}` } />
            </ReferenceInput>
            <ReferenceInput perPage="200" source="userId" reference="user">
                <SelectInput optionText="email"/>
            </ReferenceInput>
        </SimpleForm>
    </Edit>
)